import {
  HeadContent,
  Scripts,
  createRootRoute,
} from '@tanstack/react-router';

import { Toaster } from '@/components/ui/sonner';
import { AuthBootstrap } from '@/features/auth/components/auth-bootstrap';
import appCss from '../styles.css?url';

export const Route = createRootRoute({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: 'Artipilotage' },
    ],
    links: [{ rel: 'stylesheet', href: appCss }],
  }),
  shellComponent: RootDocument,
});

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html lang="fr">
      <head>
        <HeadContent />
      </head>
      <body>
        <AuthBootstrap />
        {children}
        <Toaster />
        <Scripts />
      </body>
    </html>
  );
}
